import { expVal } from '@atlassian/jira-feature-experiments';

export default {
	get(): boolean {
		return expVal('jira-itr-m4-exp-3', 'isEnabled', false);
	},
};
